/* global Iugu */

import React from "react";
import ReactDOM from "react-dom";
import injectTapEventPlugin from "react-tap-event-plugin";

import { BaseService } from "core/service";
import { BasePresenter, Base2Presenter } from "core/presenter";

import moment from "moment";
import "moment/locale/pt-br.js";

import { router } from "./router";
import App from "./components/app";

import "./index.css";

import { head } from "assets";
import { getBaseAPI } from "./util/get-base-api";

window.Chart = require("chart.js");

moment.locale("pt-br");

injectTapEventPlugin();

// Set page title
document.title = head.title;

// Set favicon
const favicon = document.createElement("link");
favicon.rel = "icon";
favicon.type = "img/png";
favicon.href = head.favicon;
document.head.appendChild(favicon);

BaseService.config({
  baseUrl: getBaseAPI()
});

BasePresenter.router = router;
Base2Presenter.router = router;

Iugu.setAccountID(process.env.REACT_APP_IUGU_TOKEN);
Iugu.setTestMode(process.env.REACT_APP_IUGU_TEST_MODE === "1");

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js